let language = {
    DELIVERY_ORDER_SUSPECTED_SANCTION_TIP: "该订单无法处理！",
};

export { language }